var lastopen=null;
var lastopensec=null;
var lastmega=null;




var firstmenuselect=null;

var secondmenuselect=null;
var thirdmenuselect=null;


var firstlevel=null;
var seclevel=null;
var thirdlevel=null;
  
var first=null;
  var sec=null;
  
 


function menuShow(event){
  if(!firstmenuselect){
  firstmenuselect=event;
    document.querySelector(`[firstlevellinkto='${event}']`).classList.add("active-menu");
    
  }
  else{
     document.querySelector(`[firstlevellinkto='${firstmenuselect}']`).classList.remove("active-menu");
      document.querySelector(`[firstlevellinkto='${event}']`).classList.add("active-menu");  
  firstmenuselect=event;
  
  }
  if(lastopensec){
    let temp=document.querySelectorAll(`[secondLevelLink='${lastopensec}']`);
    
    if(temp){
     temp[0].style.display="none";
    temp[0].classList.remove("active");
    }

  }
  if(lastopen){
    let lopen=document.querySelectorAll(`[firstlevellink='${lastopen}']`);
    if(lopen[0]){
     lopen[0].style.display="none";
    lastopen=event;
    lopen[0].classList.remove("active");
    }
   
  }
  let temp=document.querySelectorAll(`[firstlevellink='${event}']`);
  if(temp[0]){
  temp[0].style.display="block";
  temp[0].classList.add("active");
  lastopen=event;
  }
  

}



function menuShowSecond(event){ 
  
    if(!secondmenuselect){
  secondmenuselect=event;
    document.querySelector(`[secondlevellinkto='${event}']`).classList.add("active-menu");
    
  }
  else{
     document.querySelector(`[secondlevellinkto='${secondmenuselect}']`).classList.remove("active-menu");
      document.querySelector(`[secondlevellinkto='${event}']`).classList.add("active-menu");  
     secondmenuselect=event;
  
  }
  
  
  
  
  
  if(lastopensec){
    let temp=document.querySelectorAll(`[secondLevelLink='${lastopensec}']`);
    if(temp){
    
    temp[0].style.display="none";
    temp[0].classList.remove("active");
    }
  }


  let temp=document.querySelectorAll(`[secondLevelLink='${event}']`);
  if(temp[0]){
   temp[0].classList.add("active");
  temp[0].style.display="block";
  lastopensec=event;
  }


}

function divhide(event){
  document.getElementById(`${event}first`).classList.remove("active-menu-overlay")
  if(lastopensec){
  let temp=document.querySelectorAll(`[secondLevelLink='${lastopensec}']`);
    if(temp[0]){
    temp[0].style.display="none";
      lastopensec=null;
    }
  }
  if(lastopen){
   let lopen=document.querySelectorAll(`[firstlevellink='${lastopen}']`);
  if(lopen[0]){
    lopen[0].style.display="none";
      lastopen=null;
    }
  }
  
  let temp=document.getElementById(event);
  if(temp){
  temp.style.display="none";
   }
}

function megaShow(event){
  if(first!=null){
    document.getElementById(first).style.display="none";
    document.getElementById(`list${first}`).classList.remove('active-menu');
  }
  
   if(sec!=null){
     if(document.getElementById(sec)){
       document.getElementById(sec).style.display="none";}
  }
  
    if(firstlevel!=null){
      document.getElementById(`list${firstlevel}`).classList.remove("active-menu-overlay");
  }
  
  
  
  if(lastmega){
    let temp=document.getElementById(lastmega);
    if(temp){
    temp.style.display="none";
      document.getElementById(`${lastmega}first`).classList.remove("active-menu-overlay");
      lastmega=event;}
  }
  let temp=document.getElementById(event);
  if(temp){
    document.getElementById(`${event}first`).classList.add("active-menu-overlay");
   temp.style.display="flex";
  lastmega=event;
  }
}



var lastmfmenu=null;

function mobileMenu(menu){
  if(!lastmfmenu){
  lastmfmenu=menu;
let element =document.getElementById("fmenu"+menu).classList.add("active");
    document.getElementById("submenu"+menu).style.display="block";
  }
  else if(lastmfmenu==menu){
  lastmfmenu=null;
   document.getElementById("fmenu"+menu).classList.remove("active");
    document.getElementById("submenu"+menu).style.display="none"; 
  }
  else{
  
   document.getElementById("fmenu"+lastmfmenu).classList.remove("active");
    document.getElementById("submenu"+lastmfmenu).style.display="none";  
    lastmfmenu=menu;
    document.getElementById("fmenu"+menu).classList.add("active");
    document.getElementById("submenu"+menu).style.display="block";
    
    
  }

}

function playVideo(){
  setTimeout(()=>{
             document.getElementById("yt").contentWindow.postMessage('{"event":"command", "loop":1,"func":"playVideo","args":""}', '*');
}, 1000);

}

document.addEventListener('DOMContentLoaded', function() {
  var header=document.getElementById("shopify-section-announcement-bar");
  if(header){
    header.addEventListener("mouseover", function(){
      if(lastmega){ divhide(lastmega); }
    }, false);
  }
});




function megaHide(){
  if(lastmega!=null){
    document.getElementById(`${lastmega}first`).classList.remove("active-menu-overlay")
    divhide(lastmega);
  }
    if(firstlevel!=null){
      document.getElementById(`list${firstlevel}`).classList.remove("active-menu-overlay");
  }

  
}



  function countString(str, letter) {
    let count = 0;
    for (let i = 0; i < str.length; i++) {
        if (str.charAt(i) == letter) {
            count += 1;
        }
    }
    return count;
}
  
  

 
  
  function menuHoverd(data){
    if(countString(data,'#')==1){
      if(sec!=null){
        if(document.getElementById(sec)){
        document.getElementById(sec).style.display="none"
        }
      
      }
      
      
      
        if(firstlevel==null){
    firstlevel=data;
      document.getElementById(`list${firstlevel}`).classList.add('active-menu');
    }
    else{
    document.getElementById(`list${firstlevel}`).classList.remove('active-menu');
      firstlevel=data;
     document.getElementById(`list${firstlevel}`).classList.add('active-menu');    
    }
      
      
         if(seclevel!=null){
         document.getElementById(`list${seclevel}`).classList.remove('active-menu');          
         seclevel=null;
    }
         if(thirdlevel!=null){   
      		document.getElementById(`list${thirdlevel}`).classList.remove('active-menu');
            thirdlevel=null;
    }
      
      
      
      
      if(document.getElementById(first)){
    	 document.getElementById(first).style.display="none";
        document.getElementById(first).classList.add('active-menu');
      }
      
      if(document.getElementById(data)){
     document.getElementById(data).style.display="block";      
      }
      
     first=data;             
    }
    else{
           if(seclevel==null){
    seclevel=data;
      document.getElementById(`list${seclevel}`).classList.add('active-menu');
    }
    else{
    document.getElementById(`list${seclevel}`).classList.remove('active-menu');
      seclevel=data;
     document.getElementById(`list${seclevel}`).classList.add('active-menu');    
    }
      
         if(thirdlevel!=null){   
      		document.getElementById(`list${thirdlevel}`).classList.remove('active-menu');
            thirdlevel=null;
    }
      
      
      if(document.getElementById(sec)){      
      document.getElementById(sec).style.display="none";
      }
     if(document.getElementById(data)){      
     document.getElementById(data).style.display="block";
      }
      sec=data;
    }
    
}

function LastMenuRelased(data){

     
        if(thirdlevel==null){
    thirdlevel=data;
      document.getElementById(`list${thirdlevel}`).classList.add('active-menu');
    }
    else{
    document.getElementById(`list${thirdlevel}`).classList.remove('active-menu');
      thirdlevel=data;
     document.getElementById(`list${thirdlevel}`).classList.add('active-menu');    
    }
  
  
}
 



async function addItem(variantId, quantity,img = {}) {
    const result = await fetch("/cart/add.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            id: variantId,
            quantity: quantity
        })
    });
  result.json().then((data)=>{
    const myArray = data.title.split("-")
    document.getElementById('varinatSKU').innerHTML=`SKU ${data.sku}`;
   document.getElementById('varinatype').innerHTML=`Size ${myArray[1]}`;
    //document.getElementById('cartNotificationCount').innerHTML=`(${data.item_count})`; 
         document.getElementById('cart-notification').classList.add('notifyshow');
         document.getElementById('noticeOverlay').style.display="block";
    let temp=document.getElementById('cart-notification-product');
    temp.querySelector('img').src =`${img}` ;
    document.getElementById('product_tile_notification').innerHTML=`${myArray[0]}`
    
    
fetch('/?sections=ajax-cart')
            .then((response) => response.json())
            .then((data) => {
              var SectionHtml = data['ajax-cart'] ;
  if(document.querySelector('#cusomajax')){
   document.querySelector('#cusomajax').style.display="none"
  }
  if(document.querySelector('#cusomajax')){
   document.querySelector('#cusomajax').innerHTML=SectionHtml;
  }
                 
            
        
              
  setTimeout(()=>{
          document.querySelector('#cusomajax').style.display=null;   
             }, 1000);              
                      
        
  
  
      document.querySelector('#cartCountParent')
      if(document.querySelector('.cart-count-bubble span')){
      document.querySelector('.cart-count-bubble span').innerHTML= parseInt(document.querySelector('#cart-item-count').innerHTML.replace('items',''));
       
      }
      else{
        
        if(document.querySelector('#cartCountParent')){
         document.querySelector('#cartCountParent').insertAdjacentHTML("afterend",`<div class="cart-count-bubble"><span aria-hidden="true" id="cartCount">1</span><span class="visually-hidden">1 items</span>
</div>`);
          
        }
       else{
        
        document.querySelector('#cart-icon-bubble').innerHTML=`<a href="/cart" class="header__icon header__icon--cart link focus-inset" id="cart-icon-bubble"><svg class="icon icon-cart-empty" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.93195 6.68789C6.24123 6.68789 6.49195 6.43717 6.49195 6.12789V4.8591H9.43649L9.43649 6.12789C9.43649 6.43717 9.68721 6.68789 9.99649 6.68789C10.3058 6.68789 10.5565 6.43717 10.5565 6.12789V4.8591H13.0311L13.8379 14.4379C13.869 14.7863 13.7529 15.1289 13.5183 15.3844C13.2837 15.6399 12.9523 15.7847 12.6054 15.7833L12.6032 15.7833H3.15528C2.80757 15.7838 2.47649 15.6381 2.24254 15.3819C2.00859 15.1257 1.89343 14.7827 1.92533 14.4373L2.79607 4.8591H5.37195L5.37195 6.12789C5.37195 6.43717 5.62267 6.68789 5.93195 6.68789ZM6.49195 3.7391H9.43649L9.43649 2.58522C9.43453 1.88728 8.86922 1.32197 8.17286 1.32001L7.75716 1.32001C7.05922 1.32197 6.49391 1.88728 6.49195 2.58365V3.7391ZM10.5565 3.7391V2.58365C10.5528 1.26803 9.48847 0.203711 8.17443 0.200014L7.75558 0.200012C6.43997 0.203711 5.37565 1.26803 5.37195 2.58207L5.37195 3.7391H2.28467C1.99504 3.7391 1.7532 3.95996 1.72697 4.2484L0.810004 14.3351C0.749188 14.9936 0.968972 15.6481 1.41548 16.1371C1.86199 16.6261 2.49388 16.9042 3.15604 16.9033H12.6021C13.2637 16.9056 13.8958 16.6292 14.3433 16.1419C14.7911 15.6542 15.0126 15.0005 14.9537 14.341L14.1039 4.2521C14.0795 3.96207 13.8369 3.7391 13.5459 3.7391H10.5565Z" fill="currentColor"></path>
</svg>
<span class="visually-hidden" id="cartCountParent">Cart</span><div class="cart-count-bubble"><span aria-hidden="true" id="cartCount">1</span><span class="visually-hidden">1 items</span>
</div></a>
`;
      
         
         
         
        }
        
      }
      
                                 
           
            });
    
    
   
    });

  
}


function addToCart(varid,handle){
  fetch(window.Shopify.routes.root + `products/${handle}.js`)
    .then(function(r){ return r.json(); })
    .then(function(product){ addItem(varid,1,product.featured_image); });
}



function addToCartCompleteLook(varid,handle,quan){
  fetch(window.Shopify.routes.root + `products/${handle}.js`)
    .then(function(r){ return r.json(); })
    .then(function(product){ addItem(varid,quan,product.featured_image); });
}




function removeClass(evnt) {
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.swym-button');
    if(!btn) return;
    ['disabled','swym-added','swym-adding','swym-removing'].forEach(function(cls){ btn.classList.remove(cls); });
    var gridItem = btn.closest('.grid__item');
    if(gridItem){
      gridItem.querySelectorAll('.swym-heart').forEach(function(heart){
        ['disabled','swym-added','swym-adding','swym-removing'].forEach(function(cls){ heart.classList.remove(cls); });
      });
    }
  });
}
if (!window._swat) {
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(removeClass);
} else {
  removeClass();
}
setInterval(function() {
  document.querySelectorAll('.boost-pfs-filter-products .grid__item').forEach(function(item){
    if(item.querySelector('.swym-button.swym-added')){
      item.querySelectorAll('.swym-heart').forEach(function(heart){
        heart.classList.add('disabled','swym-added','swym-adding','swym-removing');
      });
    }
  });
}, 1000);

const isMobile = window.innerWidth <= 768; 

document.querySelectorAll('.product-url-link').forEach(link => {
  if (isMobile) {
    if (!link.hasAttribute('target')) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }
  } else {
    link.removeAttribute('target');
    link.removeAttribute('rel');
  }
});

